import {IncomingDocumentsComponent} from './incoming-documents/incoming-documents.component';
import {TerminalService} from '../../services/terminal.service';
import {Observable, Subject, takeUntil} from 'rxjs';
import {DocMgmtService} from '../../services/doc-mgmt.service';
import {GroupComponent} from './group/group.component';
import {UnitComponent} from './unit/unit.component';
import {FileComponent} from './file/file.component';
import {RightPanelService} from '../../services/right-panel.service';
import {UserService} from '../../services/user.service';
import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {catchError, filter, map, tap} from 'rxjs/operators';
import {HttpErrorResponse, HttpEventType} from '@angular/common/http';
import {FileMetadata} from '../../models/file-metadata.model';
import Utils from '../../utils/utils';
import {CustomTranslateService} from '../../services/custom-translate.service';
import {TidUserProfile} from '../../models/user-profile.model';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {CommonConfig} from '../shared/config/common-config';
import {TranslateService} from '@ngx-translate/core';
import {AdminLoginService} from '../../services/admin-login.service';
import {CustomerService} from '../../services/customer.service';
import {Customer} from '../../models/customer.model';
import {MatDialog} from '@angular/material/dialog';
import {PropertyDataTransferService} from '../../services/property-data-transfer.service';
import {FileKeyProperties, PropertyKey} from '../../models/fileKeyProperties.model';
import {UploadFileAssignmentDialogComponent} from '../shared/upload-file-assignment-dialog/upload-file-assignment-dialog.component';
import {
  ExtendValues,
  GetParameters,
  ParameterSortKey,
  ParameterSortOrder,
  PropertyDataService
} from 'src/app/services/property-data.service';
import { HandleErrorService } from 'src/app/services/handle-error.service';
import { Page, PageInfo } from 'src/app/models/page.model';
import {MatSelect} from '@angular/material/select';
import { FiltersComponent } from './filters/filters.component';
import { MonitoringService } from '../../utils/monitoring.service';

@Component({
  selector: 'document-dashboard',
  templateUrl: './document-dashboard.component.html',
  styleUrls: ['./document-dashboard.component.scss'],
})
export class DocumentDashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  static refreshEvent: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(FiltersComponent) filtersComponent: FiltersComponent;

  @ViewChild('panel', {static: false}) set setPanelView(
    panelView: MatSidenav
  ) {
    if (panelView) {
      this._panelview = panelView;
      this.rightPanelService.setRightPanelInstance(panelView);
      this.addScrollEventListener(panelView)
    }
  }

  @ViewChild('fileView', {static: false}) set setFileView(
    fileView: FileComponent
  ) {
    if (fileView) {
      this.fileView = fileView;
    }
  }

  @ViewChild('unitView', {static: false}) set setUnitView(
    unitView: UnitComponent
  ) {
    if (unitView) {
      this.unitView = unitView;
    }
  }

  @ViewChild('groupView', {static: false}) set setGroupView(
    groupView: GroupComponent
  ) {
    if (groupView) {
      this.groupView = groupView;
    }
  }

  @ViewChild('incomingDocumentsView', {static: false})
  set setIncomingDocumentsView(
    incomingDocumentsView: IncomingDocumentsComponent
  ) {
    if (incomingDocumentsView) {
      this.incomingDocumentsView = incomingDocumentsView;
    }
  }

  @ViewChild('fileUpload', {static: false}) fileUpload: ElementRef;
  @ViewChild('startDateInput') startDateInput: ElementRef;
  @ViewChild('endDateInput') endDateInput: ElementRef;
  @ViewChild('select', { static: false }) select: MatSelect;

  fileView: FileComponent;
  unitView: UnitComponent;
  groupView: GroupComponent;
  incomingDocumentsView: IncomingDocumentsComponent;
  selectedTab = 0;
  disableTab = true;
  showDialog = false;
  files = [];
  minimized: boolean;
  dialogHeight = 200;
  failedCount = 0;
  successCount = 0;
  uploadedCount = 0;
  maxFileSize: number;
  maxFileSizeInMb: number;
  uploadedFiles: FileMetadata[] = [];
  uploadSuccess: boolean;
  userDetailesLoaded = false;
  isWebView: boolean;
  showFilterPage = false;
  headerPosition = 'above';
  commonConfig: CommonConfig;
  filterValue: string;
  startDateFilter: Date;
  endDateFilter: Date;
  pageNumber: number;
  searchFilterValue = '';
  isIncomingDocTab: boolean;
  isTagsPage: boolean;
  INCOMINGDOC_TAB_INDEX = 3;
  TAGS_TAB_INDEX = 4;
  errorWithSizeTranslation: string;
  showFilter = false;
  showFilterApplied = false;
  protected availableColumns: string[] = ['fileName', 'createdDate', 'formattedFileSize'];
  protected selectedColumns: string[] = ['fileName', 'createdDate', 'formattedFileSize'];
  private filteredColumns: Column[] = [];
  private translatedColumns: Column[] = [];

  private readonly stop$: Subject<void> = new Subject<void>();
  private readonly DEFAULT_FILE_SIZE = 10000;
  private readonly KB_TO_MB = 1024;
  protected customerNotSelected: boolean;
  private inProgress = false;
  private readonly ACTION_COLUMN = 'actionColumn';
  private readonly MAX_SELECTABLE = 7;
  private readonly PAGE_SIZE = 20;
  private readonly FIRST_PAGE = 0;
  protected lastFetchPageInfo: PageInfo | undefined;
  private _panelview: MatSidenav;
  private readonly COLUMN_OPTIONS_SORT_PROPERTY = ParameterSortKey.ID;
  private filterInputTimeout: any;
  private searchSessionActive = false;
  private readonly COLUMN_OPTIONS_SORT_ORDER = ParameterSortOrder.ASC;

  constructor(
    private userService: UserService,
    private rightPanelService: RightPanelService,
    private docMgmtService: DocMgmtService,
    private readonly translateService: CustomTranslateService,
    private readonly terminalService: TerminalService,
    private readonly breakpointObserver: BreakpointObserver,
    private translate: TranslateService,
    private readonly adminLoginService: AdminLoginService,
    private readonly customerService: CustomerService,
    private dialog: MatDialog,
    private readonly propertyDataTransferService: PropertyDataTransferService,
    private readonly propertyDataService: PropertyDataService,
    private handleErrorService: HandleErrorService,
    private monitoringService: MonitoringService,
    private cdr: ChangeDetectorRef,
  ) {
    this.setScreenSize();
    this.commonConfig = new CommonConfig();
    translate.addLangs(['en', 'klingon']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit(): void {
    const storedColumns = sessionStorage.getItem('selectedColumns');
    if (storedColumns) {
      this.selectedColumns = JSON.parse(storedColumns);
    }
    localStorage.removeItem('filterValues');
    
    this.translatedColumns = this.availableColumns.map((key) => ({
      key,
      label: this.translateService.getTranslatedValue(key),
    }));
    this.filteredColumns = [...this.translatedColumns];
    
    this.subscribeToCustomerSelectionChange();
    this.subscribeToUserProfileChanges();
    this.initializeForm();
    this.loadCustomerDetails();

    if (!this.docMgmtService.fullFileMetadata.value) {
      this.docMgmtService.getFullFileMetadata();
    }

    this.docMgmtService.disableTab
      .pipe(takeUntil(this.stop$))
      .subscribe((value) => {
        this.disableTab = value;
      });

    DocumentDashboardComponent.refreshEvent.subscribe(() => {
      this.docMgmtService.getFileMetadata();
      this.rightPanelService.triggerFilterReset();
    });

    this.rightPanelService.filterEvent.subscribe((event) => {
      if (event.showFilter) {
        this.showFilter = event.showFilter;
      }
      if (event.reset !== undefined) {
        this.showFilterApplied = event.reset;
      }
      if (event.isFilterApplied !== undefined) {
        this.showFilterApplied = event.isFilterApplied;
      }
    });

    this.loadPropertyKeys();
  }

  onColumnOptionsScroll(event: any, select: string) {
    if (event) {
      this[select].panel.nativeElement.addEventListener('scroll', () => {
        if (Math.trunc(this[select].panel.nativeElement.scrollTop) === Math.trunc(this[select].panel.nativeElement.scrollHeight - this[select].panel.nativeElement.offsetHeight - 1)) {
          if (this.lastFetchPageInfo && !this.lastFetchPageInfo.last) {
            this.loadKeys$({
              extend: [ExtendValues.VALUES],
              page: this.lastFetchPageInfo.number + 1,
              size: this.PAGE_SIZE,
              sort: `${this.COLUMN_OPTIONS_SORT_PROPERTY},${this.COLUMN_OPTIONS_SORT_ORDER}`,
            }).subscribe();
          }
        }
      });
    }
  }

  private readonly setLastPageInfo = (page: PageInfo): void => {
    this.lastFetchPageInfo = page;
  }

  private loadKeys$(parameters: GetParameters): Observable<Page<PropertyKey>> {
    return this.propertyDataService.getKeys$(parameters).pipe(
      tap(this.handleFilePropertyKeyPageResponse)
    );
  }

  private handleFilePropertyKeyPageResponse = (data: Page<PropertyKey>): void => {
    this.setLastPageInfo(data.page);
    const propertyKeyNames = this.mapPropertyKeyNames(data);
    const uniquePropertyKeyNames = propertyKeyNames.filter(key => !this.availableColumns.includes(key));
    this.availableColumns = [...this.availableColumns, ...uniquePropertyKeyNames];
    this.translatedColumns = this.availableColumns.map((key) => ({
      key,
      label: this.translateService.getTranslatedValue(key),
    }));
    this.filteredColumns = [...this.translatedColumns];
    this.cdr.detectChanges();
  }

  private readonly mapPropertyKeyNames = (page: Page<PropertyKey>): string[] => {
    return page.content.map((propertyKey: PropertyKey) => propertyKey.global ?
                                                          propertyKey.key.toLowerCase().replace(/\s+/g, '') :
                                                          propertyKey.key);
  }

  protected onSearch(event: Event): void {
    clearTimeout(this.filterInputTimeout);

     // Send log only at the start of a typing session
    if(!this.searchSessionActive) {
      this.monitoringService.sendMonitoringLogs('FILES_SETTINGS_SEARCH_TEXT');
      this.searchSessionActive = true;
    }
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    const searchParam = searchTerm ? `${ParameterSortKey.KEY}:*${searchTerm}*` : '';
    this.loadKeys$({
      extend: [ExtendValues.VALUES],
      page: this.FIRST_PAGE,
      size: this.PAGE_SIZE,
      sort: `${this.COLUMN_OPTIONS_SORT_PROPERTY},${this.COLUMN_OPTIONS_SORT_ORDER}`,
      search: searchParam,
    }).pipe(
      takeUntil(this.stop$)
    ).subscribe(() => {
      this.filteredColumns = this.translatedColumns.filter((column) =>
        column.label.toLowerCase().includes(searchTerm))
    });

    // Reset the session flag if user stops typing for 1 second
    this.filterInputTimeout = setTimeout(() => {
      this.searchSessionActive = false;
    }, 1000);
  }

  onSearchKeydown(event: KeyboardEvent): void {
    if (event.key === ' ') {
      event.stopPropagation();
    }
  }

  onSelectionChange(selectedColumns: string[]) {
    this.monitoringService.sendMonitoringLogs('FILES_SETTINGS_TOGGLE_ITEM');
    const retainSelections = this.selectedColumns.filter(
      (column) =>
        column !== this.ACTION_COLUMN &&
        !this.filteredColumns.some((filter) => filter.key === column)
    );
    this.selectedColumns = [...retainSelections, ...selectedColumns];
    const columnOrderMap = new Map(
      this.translatedColumns.map((col, index) => [col.key, index])
    );
    this.selectedColumns.sort(
      (firstColumn, secondColumn) =>
      columnOrderMap.get(firstColumn) - columnOrderMap.get(secondColumn)
    );
      this.selectedColumns.push(this.ACTION_COLUMN);
    this.fileView.onSelectionChange(this.selectedColumns);
  }

  isMaxSelected(): boolean {
    return this.selectedColumns.length >= this.MAX_SELECTABLE;
  }

  private subscribeToCustomerSelectionChange(): void {
    this.adminLoginService.customerSelectionChanged$
      .pipe(takeUntil(this.stop$))
      .subscribe((isSelected) => {
        this.setCustomerNotSelected(!isSelected);
        if (this.customerNotSelected === false) {
          this.docMgmtService.fullFileMetadata.next([]);
          this.loadCustomerDetails();
          this.docMgmtService.getFileMetadata({
            filterValue: this.filterValue
          });
          this.docMgmtService.getFullFileMetadata();
          this.loadPropertyKeys();
        }
      });
  }

  private loadPropertyKeys(): void {
    this.loadKeys$({
      extend: [ExtendValues.VALUES],
      page: this.FIRST_PAGE,
      size: this.PAGE_SIZE,
      sort: `${this.COLUMN_OPTIONS_SORT_PROPERTY},${this.COLUMN_OPTIONS_SORT_ORDER}`,
    }).subscribe();
  }

  private subscribeToUserProfileChanges(): void {
    this.userService.tidUserProfile
      .pipe(
        takeUntil(this.stop$),
        filter(profile => !!profile && !this.userDetailesLoaded)
      )
      .subscribe((profile: TidUserProfile) => {
        this.loadAllTable(profile);
      });
  }

  private loadCustomerDetails = (): void => {
    this.customerService
      .getCustomerDetail$()
      .pipe(takeUntil(this.stop$))
      .subscribe((customer: Customer) => {
        this.setFileSizeAndLoadTable(customer);
      });
  }

  private setFileSizeAndLoadTable = (customer: Customer): void => {
    const maxDocSize = customer.maxDocSize || this.DEFAULT_FILE_SIZE;
    this.maxFileSizeInMb = Math.round(maxDocSize / this.KB_TO_MB);
    this.maxFileSize = maxDocSize * this.KB_TO_MB;
    this.translateAndSetErrorWithSize();
    // Don't call loadAllTable here - it will be called via subscription when profile is ready
  }

  private translateAndSetErrorWithSize(): void {
    this.translate.get('alert', {size: this.maxFileSizeInMb})
      .pipe(takeUntil(this.stop$))
      .subscribe(translatedMessage => {
        this.errorWithSizeTranslation = translatedMessage;
      });
  }

  private setCustomerNotSelected(value: boolean): void {
    this.customerNotSelected = value;
  }

  initializeForm(): void {
    this.searchFilterValue = this.filterValue;
  }

  setScreenSize() {
    this.breakpointObserver.observe(Breakpoints.XSmall).subscribe((result) => {
      if (result.matches) {
        this.isWebView = false;
        this.headerPosition = 'below';
      } else {
        this.isWebView = true;
        this.headerPosition = 'above';
      }
    });
  }

  refresh ()  {
    localStorage.removeItem('filterValues');
    this.rightPanelService.triggerFilterReset();
    this.monitoringService.sendMonitoringLogs('FILES_LIST_REFRESH');
    if (this.selectedTab === 0) {
      this.resetAllFileFilters();
    }
    if (this.selectedTab === 1) {
      this.terminalService.getTerminals();
    }
    if (this.selectedTab === 2) {
      this.terminalService.getTerminals();
    }
    if (this.selectedTab === 3) {
      this.incomingDocumentsView.filterValue = '';
      this.incomingDocumentsView.onResetClick();
    }
  }

  resetAllFileFilters() {
    this.filterValue = '';
  }

  loadAllTable(tidUserProfile: TidUserProfile) {
    this.translateService
      .setLanguageTranslation(tidUserProfile?.language)
      .then(() => {
        this.userDetailesLoaded = true;
        this.cdr.detectChanges();
      });
  }

  onTabChange(tab) {
    this.selectedTab = tab?.index;
    // Send monitoring logs for each tab index
    switch (this.selectedTab) {
      case 0:
        this.monitoringService.sendMonitoringLogs('FILES_TAB_SELECT');
        break;
      case 1:
        this.monitoringService.sendMonitoringLogs('UNITS_TAB_SELECT');
        break;
      case 2:
        this.monitoringService.sendMonitoringLogs('GROUPS_TAB_SELECT');
        break;
      case 3:
        this.monitoringService.sendMonitoringLogs('INCOMING_DOCUMENTS_TAB_SELECT');
        break;
      case 4:
        this.monitoringService.sendMonitoringLogs('TAGS_TAB_SELECT');
        break;
      default:
        break;
    }
    this.closePanel();
  }

  onSelectOpen(){
    this.monitoringService.sendMonitoringLogs('FILES_SETTINGS_OPEN');
  }

  openColumnSelect(): void {
    if (this.select) {
      this.select.open();
      this.onSelectOpen();
    }
  }

  closePanel() {
    this.rightPanelService.closePanel();
    this.rightPanelService.isPanelOpen.next(false);
    this.showFilter = false;
    this.fileView.clearTableSelection();
    this.unitView.clearTableSelection();
    this.groupView.clearTableSelection();
    this.rightPanelService.selectedFile.next(null);
    this.rightPanelService.selectedUnit.next(null);
    this.rightPanelService.selectedGroup.next(null);
  }

  ngOnDestroy() {
    this.stopSubscriptions();
    this.rightPanelService.selectedFile.next(null);
    this.rightPanelService.selectedGroup.next(null);
    this.rightPanelService.selectedUnit.next(null);
    this.clearComponentSessionStorage();
  }

  private clearComponentSessionStorage(): void {
    sessionStorage.removeItem('selectedColumns');
  }

  private stopSubscriptions(): void {
    this.stop$.next();
    this.stop$.complete();
  }

  closeProgresssDialog() {
    this.showDialog = false;
  }

  minimizeDialog() {
    this.minimized = !this.minimized;
    this.minimized ? (this.dialogHeight = 0) : (this.dialogHeight = 200);
  }

  onUploadClick() {
    this.files = [];
    this.uploadedFiles = [];
    this.uploadedCount = 0;
    this.failedCount = 0;
    this.successCount = 0;
    this.uploadSuccess = false;
    const fileUpload = this.fileUpload.nativeElement;
    fileUpload.onchange = () => {
      for (const file of fileUpload.files) {
        this.files.push({data: file, progress: 0});
      }
      if (this.files.length > 0) {
        const dialogRef = this.dialog.open(UploadFileAssignmentDialogComponent, {
          width: '1084px',
          height: '45%',
          panelClass: 'resizable-dialog',
          data: {
            message: this.translateService.getTranslatedValue('assignmentConfirmation'),
            propertyValuesList: this.propertyDataTransferService.getPropertyValuesList(),
            subMessage: (this.files.length === 1) ?
                        this.files[0].data.name :
                        `${this.files.length} ${this.translateService.getTranslatedValue('documentsSelected')}`
          }
        });
        dialogRef.componentInstance.tagsAssigned.subscribe((properties: FileKeyProperties[]) => {
          const propertyValuesIds = new Set(properties.flatMap(property => property.values)
                                                      .map(propertyValue => propertyValue.id));
          this.showDialog = true;
          this.setInProgress(true);
          this.uploadFiles(propertyValuesIds);
        });
      }
    };
    fileUpload.click();
  }

  private uploadFiles(propertyValuesIds: Set<number>): void {
    this.fileUpload.nativeElement.value = '';
    this.files.forEach((file) => {
      if (file.data.size < this.maxFileSize) {
        this.uploadFile(file, propertyValuesIds);
      } else {
        file.alert = true;
        this.uploadedCount = this.uploadedCount + 1;
        this.failedCount = this.failedCount + 1;
        if (this.uploadedCount === this.files.length) {
          this.setInProgress(false);
        }
      }
    });
  }
  uploadFile(file: any, propertyValuesIds: Set<number>) {
    const formData = new FormData();
    formData.append('file', file.data);
    if (propertyValuesIds.size > 0) {
      const propertiesIdsJson = JSON.stringify([...propertyValuesIds]);
      formData.append('propertyValueIds', new Blob([propertiesIdsJson], { type: 'application/json' }));
    }
    this.docMgmtService
      .upload(formData)
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              file.progress = Math.round((event.loaded * 100) / event.total);
              break;
            case HttpEventType.Response:
              return event;
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.uploadedCount = this.uploadedCount + 1;
          this.failedCount = this.failedCount + 1;
          file.failure = true;
          if (this.uploadedCount === this.files.length) {
            this.loadFiles(this.uploadedFiles);
            this.setInProgress(false);
          }
          return `${file.data.name} upload failed.`;
        })
      )
      .subscribe((event: any) => {
        if (typeof event === 'object') {
          this.uploadedCount = this.uploadedCount + 1;
          this.successCount = this.successCount + 1;
          file.success = true;
          const uploadedFile: FileMetadata = new FileMetadata();
          uploadedFile.fileKey = event.body.fileId;
          uploadedFile.fileType = file.data.type;
          uploadedFile.fileName = file.data.name;
          uploadedFile.createdDate = new Date().getTime().toString();
          uploadedFile.fileSize = file.data.size;
          uploadedFile.formattedFileSize = Utils.bytesToSize(file.data.size);
          this.uploadedFiles.push(uploadedFile);
          if (this.uploadedCount === this.files.length) {
            this.loadFiles(this.uploadedFiles);
            this.setInProgress(false);
          }
          if (
            this.uploadedCount === this.files.length &&
            this.failedCount === 0
          ) {
            this.uploadSuccess = true;
          }
        }
      });
  }

  loadFiles(uploadedFiles) {
    this.resetAllFileFilters();
    const formattedFiles = Utils.formatFiles(uploadedFiles);
    const fileData = this.docMgmtService.fullFileMetadata.value;
    const newFileList = formattedFiles.concat(fileData);
    this.docMgmtService.fullFileMetadata.next(newFileList);
  }

  filter() {
    this.showFilterPage = true;
    this.isIncomingDocTab = false;
    this.isTagsPage = false;
  }

  closeFilterPage(event: number) {
    this.showFilterPage = false;
    this.selectedTab = event;
  }

  openFilterPanel() {
    this.monitoringService.sendMonitoringLogs('FILES_FILTER_OPEN');
    this.showFilter = true;
    this.rightPanelService.isPanelOpen.next(true);
    this.rightPanelService.showFilter(this.showFilterApplied);
  }

  filterValueEvent(event): void {
    this.pageNumber = event.pageNumber;
    this.searchFilterValue = event.filterValue;
  }

  applyFilter(value) {
    clearTimeout(this.filterInputTimeout);

    // Send log only at the start of a typing session
    if (!this.searchSessionActive) {
      this.monitoringService.sendMonitoringLogs('FILES_SEARCH_TEXT');
      this.searchSessionActive = true;
    }
    this.filterValue = value?.trim()?.toLowerCase();

    // Reset the session flag if user stops typing for 1 second
    this.filterInputTimeout = setTimeout(() => {
      this.searchSessionActive = false;
    }, 1000);
  }

  setFilterPage(event) {
    this.showFilterPage = event;
    this.isIncomingDocTab = true;
    this.isTagsPage = true;
  }

  protected getInProgress(): boolean {
    return this.inProgress;
  }

  protected setInProgress(value: boolean): void {
    this.inProgress = value;
  }

  onFilterClose(event: MouseEvent) {
    this.monitoringService.sendMonitoringLogs('FILES_FILTER_CLEAR');
    event.stopPropagation();
    this.rightPanelService.triggerFilterReset();
  }

  ngAfterViewInit(): void {
    if(this._panelview){
      this.addScrollEventListener(this._panelview);
    }
  }

  private addScrollEventListener(panelView: MatSidenav) {
    const panelElement = panelView._content.nativeElement;
    panelElement.addEventListener('scroll', this.onPanelScroll.bind(this));
  }

  onPanelScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (this.filtersComponent) {
        this.filtersComponent.onScroll();
      }
    }
  }
}
interface Column {
  key: string;
  label: string;
}
